import { HEADER_GROUP, useBookingRecoilValue, useBookingYeogiRecoilValue, useNewNavigate } from "@/shared/client";
import { MEDIA } from "@/styles/common";
import { Center } from "@chakra-ui/react";
import { CustomCenter, CustomSubText, CustomTitle } from "./deatilMenuBar.style";
import { type DetailMenuBarProps } from "./detailMenuBar.type";

export const DetailMenuBar = ({ navigation }: DetailMenuBarProps) => {
    const { onNavigate } = useNewNavigate();
    const bookingURL = useBookingRecoilValue();
    const bookingYeogi = useBookingYeogiRecoilValue();
    const { isMobile } = MEDIA();
    const onLink = (url: string) => {
        if (bookingURL.includes("http")) {
            window.open(url, "_blank");
        }
        if (!bookingURL.includes("http")) {
            window.open(`https://${url}`, "_blank");
        }
    };
    return (
        <CustomCenter
            overflow={isMobile ? "auto" : ""}
            flexDir="column"
            justifyContent={isMobile ? "flex-start" : "center"}
            rowGap="16px"
        >
            {HEADER_GROUP.map((header) => (
                <Center w="100%" key={header.title} flexDir="column">
                    <CustomTitle as="h4" key={header.title}>
                        {header.title}
                    </CustomTitle>
                    <Center w="50%" columnGap="12px" flexWrap="wrap">
                        {header.title === "Specials" &&
                            navigation?.specialList &&
                            navigation.specialList.map((special) => (
                                <CustomSubText
                                    onClick={() => onNavigate({ path: `/specials/${special.special_idx}` })}
                                    key={special.special_idx}
                                    p="12px 0"
                                >
                                    {special.special_name}
                                </CustomSubText>
                            ))}

                        {header.title === "Rooms" &&
                            navigation?.roomList &&
                            navigation.roomList.map((room) => (
                                <CustomSubText
                                    onClick={() => onNavigate({ path: `/rooms/${room.room_idx}` })}
                                    key={room.room_idx}
                                    p="12px 0"
                                >
                                    {room.room_name}
                                </CustomSubText>
                            ))}

                        {header.title === "Reservation" &&
                            header.contents.map((content) => {
                                if (content.title === "여기어때 예약") {
                                    if (bookingYeogi === "") {
                                        return null;
                                    }
                                    return (
                                        <CustomSubText key={content.title} onClick={() => onLink(bookingYeogi)}>
                                            {content.title}
                                        </CustomSubText>
                                    );
                                }
                                return (
                                    <CustomSubText
                                        onClick={() => {
                                            return onLink(bookingURL);
                                        }}
                                        key={content.title}
                                        p="12px 0"
                                    >
                                        {content.title}
                                    </CustomSubText>
                                );
                            })}

                        {header.title !== "Reservation" &&
                            header.title !== "Rooms" &&
                            header.title !== "Specials" &&
                            header.contents.map((content) => {
                                return (
                                    <CustomSubText
                                        onClick={() => onNavigate({ path: content.path })}
                                        key={content.title}
                                        p="12px 0"
                                    >
                                        {content.title}
                                    </CustomSubText>
                                );
                            })}
                    </Center>
                </Center>
            ))}
        </CustomCenter>
    );
};
